// extracted by mini-css-extract-plugin
export default {"container":"fJgsdA7d","static":"swvIvbGd","details":"K7iB61lh","detailsIcon":"WDhuwtt6"};